import * as Yup from 'yup';
import USAStates from '../../json';

const address = Yup.string()
    .min(2, 'Address must be at least 2 characters long.')
    .max(200, 'Address must be no longer than 200 characters.');
const addressRequired = address.required('This is a required field.');
const city = Yup.string()
    .min(2, 'City must be at least 2 characters long.')
    .max(200, 'City must be no longer than 200 characters.');
const cityRequired = city.required('This is a required field.');
const stateUSAbbrev = Yup.mixed().oneOf(
    USAStates.map((stateItem) => {
        return stateItem.Abbr;
    }),
    'Select a valid US State'
);
const stateUSAbbrevRequired = stateUSAbbrev.required('This is a required field.');

const catalogFields = {
    address,
    addressRequired,
    city,
    cityRequired,
    stateUSAbbrev,
    stateUSAbbrevRequired,
};
export default catalogFields;
